import { RouteConfig } from 'vue-router';
import { Component } from 'vue';
import { BookingLinkRoute } from '@/modules/bookinglink/routes/BookingLinkRoute';
import BookingLinkLayout from '@/modules/bookinglink/pages/BookingLinkLayout.vue';

export const router: RouteConfig[] = [
  {
    path: '/',
    name: 'booking-link-external',
    component: BookingLinkLayout,
    children: [
      {
        path: BookingLinkRoute.BOOKING_LINK.path,
        name: BookingLinkRoute.BOOKING_LINK.name,
        component: (): Promise<{ default: Component }> =>
          import(
            '/@/modules/bookinglink/components/stateful/flow/unprotected/BookingLinkFlow_Start.vue'
          ),
        meta: { authOnly: false }
      }
    ]
  }
];
